import { useNavigate } from 'react-router-dom';

import './Card.css'

function Card({ guitar }) {
    const navigate = useNavigate();

    return (
        <div className="shop__card" onClick={() => { navigate(`/shop/${guitar.id}`) }}>
            <img src={`${process.env.PUBLIC_URL}/guitar/guitar-${guitar.id}-${guitar.title}.jpg`} alt={guitar.name} className="shop__card-image" />
            <h3 className="shop__card-title">{guitar.title}</h3>
            <p className="shop__card-price">{guitar.price.toLocaleString()}</p>
            <p className="shop__card-updated">{guitar.updated}</p>
        </div>
    )
}

export default Card;